import { useState } from "react";

function FileUploadField({ register, errors }) {
  const [uploadedImages, setUploadedImages] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setUploadedImages((prevImages) => [...prevImages, ...imageUrls]); // Append new images to the existing ones
  };

  const handleRemoveImage = (index) => {
    setUploadedImages((prevImages) => prevImages.filter((_, i) => i !== index));
  }

  return (
    <div className="form-group">
      <label htmlFor="fahrzeugbilder_hinzufügen">Fahrzeugbilder hinzufügen</label>
      <div className="file-upload-field">
        <input
          type="file"
          id="fahrzeugbilder_hinzufügen"
          multiple
          accept=".png, .jpg, .jpeg, image/png, image/jpeg"
          {...register('fahrzeugbilder_hinzufügen', {
            required: "Fahrzeugbilder hinzufügen is required",
            onChange: handleFileChange,
          })}
          style={{ display: "none" }}
        />
        <label htmlFor="fahrzeugbilder_hinzufügen" className="upload-circle" style={{ cursor: "pointer" }}>
          <span className="plus-icon">+</span>
        </label>
        <div className="image-preview">
          {uploadedImages.map((image, index) => (
            <div className="image-thumb" key={index}>
              <img src={image} alt={`Uploaded ${index + 1}`} />
              <button
                type="button"
                className="remove-btn"
                onClick={() => handleRemoveImage(index)}
                title="Entfernen"
              >
                ×
              </button>
            </div>
          ))}
        </div>
      </div>
      {errors.fahrzeugbilder_hinzufügen && (
        <p className="error">{errors.fahrzeugbilder_hinzufügen.message}</p>
      )}
    </div>
  );
}

export default FileUploadField;